// extracted by mini-css-extract-plugin
export default {"img":"img--Cmqym3iTnFMCC5sHvRVn"};